var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.04 3.307A12.769 12.769 0 0 0 6.103 8c-1.462 1.81-2.391 3.966-2.722 6.32-.121.863-.121 2.497 0 3.36.808 5.741 5.198 10.131 10.939 10.939.863.121 2.497.121 3.36 0 5.74-.808 10.137-5.205 10.938-10.939.12-.861.12-2.499 0-3.36-.791-5.662-5.156-10.09-10.751-10.906-.816-.119-2.075-.167-2.827-.107m2.8 1.569c2.345.428 4.272 1.394 5.914 2.964 1.813 1.734 2.903 3.782 3.376 6.347.072.39.094.799.095 1.786.001 1.37-.032 1.673-.296 2.755-.769 3.15-2.963 5.885-5.889 7.343-1.059.528-1.969.826-3.227 1.059-.723.134-2.903.134-3.626 0-2.406-.445-4.306-1.399-5.965-2.995-1.81-1.741-2.877-3.753-3.352-6.322-.134-.723-.134-2.903 0-3.626.445-2.406 1.399-4.306 2.995-5.965 1.847-1.92 4.201-3.103 6.802-3.42.619-.075 2.609-.028 3.173.074m-.867 6.484c-.327.199-.478.625-.327.924.032.064.698.758 1.479 1.543l1.421 1.426-4.506.003c-3.348.003-4.553.02-4.688.067-.281.098-.404.304-.404.677 0 .373.123.579.404.677.135.047 1.34.064 4.688.067l4.506.003-1.421 1.426c-.781.785-1.447 1.479-1.479 1.543-.277.548.425 1.25.971.971.134-.069 4.296-4.179 4.394-4.34.036-.059.065-.215.065-.347 0-.132-.029-.288-.065-.347-.098-.161-4.26-4.271-4.394-4.34-.178-.091-.451-.071-.644.047",
    fillRule: "evenodd",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeArrowRight);
export default __webpack_public_path__ + "static/media/icone-arrow-right.a9c7686e2d83b50fe4b9f59b8657bb51.svg";
export { ForwardRef as ReactComponent };